// Maps each achievement icon key from the definition to its icon.

import {
  DramaIcon,
  HouseIcon,
  PartyPopperIcon,
  PlugIcon,
  type LucideIcon,
} from 'lucide-react';
import type { AchievementIcon } from '@airhead-games/shared/types';

export const ACHIEVEMENT_ICON_COMPONENTS: Record<AchievementIcon, LucideIcon> =
  {
    plug: PlugIcon,
    partyPopper: PartyPopperIcon,
    drama: DramaIcon,
    house: HouseIcon,
  };
